import { LayoutDashboard, BookOpen, Users, GraduationCap, Handshake } from 'lucide-react'

interface AdminBottomNavProps {
    activeTab: string
    setActiveTab: (tab: string) => void
}

const navItems = [
    { id: 'dashboard', label: 'Home', icon: LayoutDashboard },
    { id: 'courses', label: 'Courses', icon: BookOpen },
    { id: 'mentors', label: 'Mentors', icon: Users },
    { id: 'abroad-colleges', label: 'Abroad', icon: GraduationCap },
    { id: 'coaching-tieups', label: 'Tie-ups', icon: Handshake },
]

export function AdminBottomNav({ activeTab, setActiveTab }: AdminBottomNavProps) {
    return (
        <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800 safe-bottom">
            <div className="grid grid-cols-5 h-16">
                {navItems.map((item) => {
                    const Icon = item.icon
                    const isActive = activeTab === item.id
                    return (
                        <button
                            key={item.id}
                            onClick={() => setActiveTab(item.id)}
                            className={`flex flex-col items-center justify-center gap-1 relative transition-colors ${isActive ? 'text-primary-blue' : 'text-slate-400 dark:text-slate-500'}`}
                        >
                            <Icon className="h-5 w-5" />
                            <span className="text-xs font-medium">{item.label}</span>
                            {isActive && (
                                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-12 h-1 bg-primary-blue rounded-b-full" />
                            )}
                        </button>
                    )
                })}
            </div>
        </div>
    )
}
